import { createCrudActions } from '../utils/crudGenerator';

const formatTasks = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchTasks,
    create: createTask,
    update: updateTask,
    delete: deleteTasks
} = createCrudActions('TASK', "Tarea", formatTasks);
